import { Option } from '@/interfaces/option';
import { EntityResource } from './entity.resource';
import { OptionFilterVariables } from './queryVariables/filters/filters';

/**
 * Resource Opcji
 *
 * @export
 * @class OptionResource
 * @extends {EntityResource<Option>}
 */
export class OptionResource extends EntityResource<Option> {
  public getFields = {
    id: true,
    name: true
  };

  public listFields = {
    id: true,
    name: true,
    code: true,
    defaultValue: true,
    description: true,
    type: true
  };

  protected listVariables = OptionFilterVariables;

  constructor() {
    super({
      entityName: 'option'
    });
  }
}

export const optionResource = new OptionResource();
